import { getAccessToken, refreshAccessToken } from './api.js';

/**
 * Downloads an authenticated file as a browser save, refreshing the access token once. The link
 * is put in the page for the click (Firefox ignores one that is not), and the address is kept for
 * a minute so a slow phone can finish reading the file.
 */
export async function downloadFile(path: string, filename: string): Promise<void> {
  const send = () =>
    fetch(`/api/v1${path}`, {
      credentials: 'same-origin',
      headers: getAccessToken() ? { authorization: `Bearer ${String(getAccessToken())}` } : {},
    });
  let response = await send();
  if (response.status === 401 && (await refreshAccessToken())) response = await send();
  if (!response.ok) throw new Error(`Download failed with status ${String(response.status)}`);
  const blob = await response.blob();
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.hidden = true;
  document.body.append(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(link.href), 60_000);
}
